document.addEventListener("DOMContentLoaded", function () {
  const product_loader = document.getElementById("product_loader");
  product_loader.classList.add("loading");
  const observer = new MutationObserver(() => {
    const calculator = document.querySelector("#calculator");
    if (calculator) {
      observer.disconnect();
      document.getElementById("product_loader").classList.remove("loading");
      initCustomPayments(calculator);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  function initCustomPayments(calculator) {
    const priceInput = document.getElementById("payment-amount");
    const instructionsInput = document.getElementById("payment-instructions");
    const uploadToggle = document.getElementById("upload-toggle");
    const uploadSection = document.getElementById("upload-section");
    const fileInput = document.querySelector(".calc-prop.cpc-file-upload");
    const finishPayBtn = document.getElementById("finish-pay-btn");
    const artworkBox = document.querySelector(".artwork-box");

    const priceField = calculator.querySelector(
      "input[name='properties[Custom Price]']"
    );
    const instructionField = calculator.querySelector(
      "textarea[name='properties[Instructions]']"
    );

    // Sync price input
    priceInput.addEventListener("input", (e) => {
      if (e.target.value.trim() !== "") {
        priceInput.classList.add("variant-picked");
        priceField.value = e.target.value;
      } else {
        priceInput.classList.remove("variant-picked");
        priceField.value = 1;
      }

      safePriceUpdation();
    });

    function safePriceUpdation() {
      if (typeof window.PriceUpdation === "function") {
        window.PriceUpdation();
        console.log("✅ Price updated successfully.");
      } else {
        console.warn("⚠️ PriceUpdation function not available. Retrying...");
        let retry = setInterval(() => {
          if (typeof window.PriceUpdation === "function") {
            clearInterval(retry);
            console.log("✅ PriceUpdation function found. Executing...");
            window.PriceUpdation();
          }
        }, 500);
      }
    }

    // Sync instructions input
    instructionsInput.addEventListener("input", (e) => {
      if (e.target.value.trim() !== "") {
        instructionsInput.classList.add("variant-picked");
        instructionField.value = e.target.value;
      } else {
        instructionsInput.classList.remove("variant-picked");
        instructionField.value = "";
      }
    });

    // Toggle file upload section
    uploadToggle.addEventListener("change", (e) => {
      uploadSection.style.display = e.target.checked ? "block" : "none";

      // Safely set checkbox value if it exists in the calculator
      if (calculator) {
        calculator.querySelector(
          "input.checkbox[name='properties[Upload Files]']"
        ).checked = e.target.checked;
      }

      // Reset file input if unchecked
      if (!e.target.checked) {
        fileInput.value = "";
        filePathContainer.style.display = "none";
        filePathText.textContent = "";
      }
    });

    // Handle file selection like in Print Custom Stickers
    const chooseFileBtn = document.getElementById("choose-file-btn");
    const filePathContainer = document.getElementById("file-path");
    const filePathText = filePathContainer.querySelector("p");

    // Choose File button click opens file dialog
    chooseFileBtn.addEventListener("click", () => {
      fileInput.click();
    });

    // Display selected file name in UI
    fileInput.addEventListener("change", (event) => {
      const file = event.target.files[0];
      if (file) {
        filePathContainer.style.display = "block";
        const fullName = file.name;
        if (fullName.length > 30) {
          const start = fullName.slice(0, 8);
          const end = fullName.slice(-9); // You can adjust this
          filePathText.textContent = `${start}....${end}`;
        } else {
          filePathText.textContent = fullName;
        }
      } else {
        filePathContainer.style.display = "none";
        filePathText.textContent = "";
      }
    });

    function blinkElement(
      element,
      className = "blink-border",
      blinks = 4,
      interval = 200
    ) {
      if (!element) return;

      for (let i = 0; i < blinks * 2; i++) {
        setTimeout(() => {
          element.classList.toggle(className);
          element.classList.toggle("error-border")
        }, i * interval);
      }
    }

    // Final button click
    finishPayBtn.addEventListener("click", () => {
      // Check if file is required and not uploaded
      const isUploadRequired = uploadToggle.checked;
      const hasFile = fileInput.files && fileInput.files.length > 0;

      if (isUploadRequired && !hasFile) {
        blinkElement(artworkBox);
        return;
      }

      // If validation passes
      product_loader.classList.add("loading");
      document.getElementById("AddToCart").click();
    });
  }
});
